export const environment = {
    production: false,
    apiUrl: "https://api.testes.gestor-externo.asmontech.online",
    siteUrl: "https://testes.gestor-externo.asmontech.online",
    nominatimUrl: "https://nominatim.openstreetmap.org"
};
